import { render, staticRenderFns } from "./XhReceivablesPlan.vue?vue&type=template&id=9e35f274&scoped=true"
import script from "./XhReceivablesPlan.vue?vue&type=script&lang=js"
export * from "./XhReceivablesPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e35f274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e35f274')) {
      api.createRecord('9e35f274', component.options)
    } else {
      api.reload('9e35f274', component.options)
    }
    module.hot.accept("./XhReceivablesPlan.vue?vue&type=template&id=9e35f274&scoped=true", function () {
      api.rerender('9e35f274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhReceivablesPlan.vue"
export default component.exports